/**
 * Universo inventado para las maquetas de las páginas públicas. Solo adultos
 * y nombres ficticios: ninguna pantalla muestra jugadores reales (hay torneos
 * infantiles en la plataforma). Las cifras cuadran entre sí.
 */
import type { BracketMatch, BracketRound } from "../../lib/bracketLayout";

export const MOCK_CLUB = { name: "Club Arboleda", initials: "CA" };

export const MOCK_TOURNAMENT = {
  name: "Copa Otoño 2026",
  dates: "17 al 19 de octubre de 2026",
  shortDates: "17 al 19 oct",
  slug: "copa-otono-2026",
  courts: 4,
};

export const MOCK_CATEGORIES = ["Varonil Abierta B", "Femenil 4.0", "Dobles mixto"];

export const MOCK_PRICES = [
  { label: "General", amount: 850 },
  { label: "Socio Arboleda", amount: 650 },
  { label: "Dobles mixto", amount: 400 },
];

/** 52 órdenes: 48 pagadas (40 × $850 + 8 × $1,250) y 4 pendientes × $850. */
export const MOCK_MONEY = {
  orders: 52,
  paid: 48,
  paidPercent: 92,
  collected: 44_000,
  pending: 3_400,
  platformFee: 4_752,
  netBeforeMp: 39_248,
  mpFee: 2_004,
  net: 37_244,
};

export const MOCK_ELIM_PLAYERS = {
  salazar: "Diego Salazar",
  aguilar: "Tomás Aguilar",
  herrera: "Luis Herrera",
  torres: "Emilio Torres",
  navarro: "Jorge Navarro",
  pena: "Raúl Peña",
  castro: "Iván Castro",
  ruiz: "Andrés Ruiz",
};

export const MOCK_GROUP_A = [
  { name: "Mariana Ortiz", record: "3-0" },
  { name: "Paola Méndez", record: "2-1" },
  { name: "Valeria Rivas", record: "1-2" },
  { name: "Sofía Cárdenas", record: "0-3" },
];

export const MOCK_LADDER = [
  { name: "Regina Fuentes", move: 0 },
  { name: "Camila Robles", move: 1 },
  { name: "Valeria Rivas", move: -1 },
  { name: "Sofía Cárdenas", move: 2 },
  { name: "Paola Méndez", move: 0 },
];

export function formatMxn(amount: number): string {
  return new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
}

function side(name: string, seed: number | null, games: number[], isWinner: boolean) {
  return { name, seed, games, isWinner };
}

function match(id: string, number: number, top: ReturnType<typeof side>, bottom: ReturnType<typeof side>): BracketMatch {
  return { id, number, top, bottom, pending: false };
}

const P = MOCK_ELIM_PLAYERS;

/** Cuadro de 8 de Varonil Abierta B, completo, para `EliminationBracket`. */
export const MOCK_BRACKET_ROUNDS: BracketRound[] = [
  {
    label: "Cuartos de final",
    matches: [
      match("qf1", 1, side(P.salazar, 1, [6, 6], true), side(P.aguilar, null, [2, 3], false)),
      match("qf2", 2, side(P.herrera, null, [4, 6, 10], true), side(P.torres, null, [6, 3, 7], false)),
      match("qf3", 3, side(P.navarro, null, [6, 7], true), side(P.pena, null, [4, 5], false)),
      match("qf4", 4, side(P.castro, null, [1, 4], false), side(P.ruiz, 2, [6, 6], true)),
    ],
  },
  {
    label: "Semifinal",
    matches: [
      match("sf1", 5, side(P.salazar, 1, [6, 3, 10], true), side(P.herrera, null, [4, 6, 8], false)),
      match("sf2", 6, side(P.navarro, null, [5, 4], false), side(P.ruiz, 2, [7, 6], true)),
    ],
  },
  {
    label: "Final",
    matches: [match("f", 7, side(P.salazar, 1, [6, 3, 6], true), side(P.ruiz, 2, [4, 6, 4], false))],
  },
];

export const MOCK_THIRD_PLACE: BracketMatch = match(
  "third",
  8,
  side(P.herrera, null, [6, 6], true),
  side(P.navarro, null, [3, 2], false),
);

export function initialsOf(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("");
}
